import { createFileRoute } from '@tanstack/react-router'
import { FacilityModelPage } from 'pages/facilityModel/FacilityModelPage'
import { facilityModelSearchParams } from 'routes/facility-model/-searchParams'

const RouteComponent = () => {
  const search = Route.useSearch()
  return <FacilityModelPage siteId={search.siteId ?? null} search={search} />
}

export const Route = createFileRoute('/facility-model/')({
  component: RouteComponent,
  validateSearch: facilityModelSearchParams,
  staticData: {
    title: 'Facility Model',
    layout: {
      enableScrolling: false,
    },
  },
})
